import { RouterView } from "vue-router";
import { warehousingRouting }  from './warehousing/warehousing.routing'
import { retreatRouting } from './retreat/retreat.routing'
import { maintainInfoRouting } from './maintainInfo/maintainInfo.routing'
import { reductionRouting } from './reduction/reduction.routing'
export const AssetManageRouting = {
  path: "/assetManage",
  name: "assetManage",
  component: RouterView,
  meta: { title: "企业资产管理", icon: "asset" },
  children: [
		...warehousingRouting,
		...retreatRouting,
		...maintainInfoRouting,
		...reductionRouting
  ],
};